var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSynthese(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1699",
    "data-name": "Rectangle 1699",
    width: 38.571,
    height: 37.571,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-SYNTHESE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SYNTHESE",
    clipPath: "url(#clip-SYNTHESE)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2584",
    "data-name": "Groupe 2584",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2583",
    "data-name": "Groupe 2583",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7005",
    "data-name": "Trac\\xE9 7005",
    d: "M33.431,2.588a1.4,1.4,0,0,1,1,.422,1.674,1.674,0,0,1,.466,1.18V5.2H31.858V4.148a1.561,1.561,0,0,1,1.572-1.56m-6.924,0a7.13,7.13,0,0,0-.175,1.566V33.894H2.588V4.159A1.561,1.561,0,0,1,4.154,2.592H26.506M33.429.5h-.01A3.65,3.65,0,0,0,29.77,4.148V7.293h7.213V4.19a3.772,3.772,0,0,0-1.048-2.627A3.491,3.491,0,0,0,33.429.5M30.006.5H4.133A3.641,3.641,0,0,0,.5,4.159V35.983H28.419V4.159A4.924,4.924,0,0,1,29.881.629Z",
    transform: "translate(0.544 0.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_106",
    "data-name": "Ligne 106",
    d: "M18.706.5H0v-1H18.706Z",
    transform: "translate(5.382 12.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_107",
    "data-name": "Ligne 107",
    d: "M18.706.5H0v-1H18.706Z",
    transform: "translate(5.382 17.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_108",
    "data-name": "Ligne 108",
    d: "M18.706.5H0v-1H18.706Z",
    transform: "translate(5.382 21.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_109",
    "data-name": "Ligne 109",
    d: "M18.706.5H0v-1H18.706Z",
    transform: "translate(5.382 26.123)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynthese);
export default __webpack_public_path__ + "static/media/SYNTHESE.284f68f9486ba980e9f19ed67f3bd773.svg";
export { ForwardRef as ReactComponent };